export default __webpack_public_path__ + "3ecbdf991d6e340640d44977e0f412b3.svg";